import React from 'react';
import { IconButton, Popover, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { EditAttributesOutlined, MoreVertOutlined } from '@material-ui/icons';
import { useModeratorActions } from './useModeratorActions';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import { usePopover } from 'hooks';

export interface ModeratorActionsButtonProps {
  userId: string;
  disabled: boolean;
}

export const ModeratorActionsButton = (props: ModeratorActionsButtonProps) => {
  const { userId, disabled } = props;
  const { id, onClick, onClose, open, anchorEl } = usePopover(userId);
  const { onDelete, onChangePassword, onEdit, onEnableOrDisable, loading } = useModeratorActions(
    userId,
    disabled,
    onClose
  );

  return (
    <>
      <IconButton aria-describedby={id} aria-label="Действия" onClick={onClick}>
        <MoreVertOutlined />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <List component="nav" aria-label="Основный действия над администратором">
          <ListItem button onClick={onEdit} disabled={loading}>
            <ListItemIcon>
              <EditOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Изменить" />
          </ListItem>
          <ListItem button onClick={onChangePassword} disabled={loading}>
            <ListItemIcon>
              <EditAttributesOutlined />
            </ListItemIcon>
            <ListItemText primary="Изменить пароль" />
          </ListItem>
          <ListItem button onClick={onEnableOrDisable} disabled={loading}>
            <ListItemIcon>{disabled ? <CheckCircleIcon /> : <BlockIcon />}</ListItemIcon>
            <ListItemText primary={disabled ? 'Активировать' : 'Заблокировать'} />
          </ListItem>
          <ListItem button onClick={onDelete} disabled={loading}>
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            <ListItemText primary="Удалить" />
          </ListItem>
        </List>
      </Popover>
    </>
  );
};
